import { Image, Page, StyleSheet, View } from "@react-pdf/renderer";
import React from "react";
import { getPresignedUrl } from "../../upload/utils";
import { CostData, getAllPdfPageS3Keys, getFooter } from "../../../utils/helperUtils";

const styles = StyleSheet.create({
    page: {
        padding: "40px 50px",
        backgroundColor: "#ffffff",
        position: "relative",
    },
    mainContainer: {
        flex: 1,
        paddingBottom: 50,
    },
    imageContainer: {
        width: "100%",
        height: "75vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid #e0e0e0",
        borderRadius: 4,
        backgroundColor: "#f8f9fa",
        padding: "10px",
    },
    image: {
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
    },
});

interface CostMVSImagesPageProps {
    data: CostData;
    confidentialInfo: string;
}

const ImagePage: React.FC<{
    imageS3Key: string;
    confidentialInfo: string;
}> = ({ imageS3Key, confidentialInfo }) => (
    <Page size="A4" style={styles.page}>
        <View style={styles.mainContainer}>
            <View style={styles.imageContainer}>
                <Image source={getPresignedUrl(imageS3Key)} style={styles.image} />
            </View>
        </View>

        {getFooter(confidentialInfo)}
    </Page>
);

export const CostMVSImagesPage: React.FC<CostMVSImagesPageProps> = ({ data, confidentialInfo }) => {
    const imageS3Keys = getAllPdfPageS3Keys(data);

    return (
        <>
            {imageS3Keys.map((imageS3Key, index) => (
                <ImagePage
                    key={`mvs-image-${index}`}
                    imageS3Key={imageS3Key}
                    confidentialInfo={confidentialInfo}
                />
            ))}
        </>
    );
};
